import OpportunityCalculator from './OpportunityCalculator';

export default OpportunityCalculator;
